const ENDPOINT = "https://api.web3forms.com/submit";
const MIN_FILL_MS = 2500;

export async function submitToWeb3Forms({ data, subject, from_name, botcheck, startedAt }) {
  const accessKey = process.env.REACT_APP_WEB3FORM_ACCESS_KEY;
  if (!accessKey) throw new Error("Form is not configured. Please try again later.");

  if (botcheck) return { success: true, silent: true };
  if (startedAt && Date.now() - startedAt < MIN_FILL_MS) {
    return { success: true, silent: true };
  }

  const payload = {
    access_key: accessKey,
    subject: subject || "New inquiry — Myriad Green Energy",
    from_name: from_name || "Myriad Green Energy Website",
    ...data,
  };

  const res = await fetch(ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(payload),
  });

  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    throw new Error(json.message || "Submission failed. Please try again.");
  }
  return { success: true };
}
